<template>
  <b-modal
    id="add-recipient-modal"
    :title="trans('add_recipient')"
    :ok-title="trans('add')"
    :ok-disabled="busy || !canSave"
    :cancel-title="trans('cancel')"
    @ok="onSave"
    @shown="onShown"
  >
    <b-form-group :label="trans('name')">
      <b-form-input v-model="name" size="sm" :disabled="busy" />
    </b-form-group>
    <b-form-group>
      <label>
        {{ trans('email') + (isEmailRequired ? ' *' : '') }}
      </label>
      <b-form-input
        ref="email"
        :state="isEmailRequired ? isEmailValid : null"
        type="email"
        v-model="email"
        size="sm"
        :disabled="busy"
        @keydown="onKeydown"
        :required="isEmailRequired"
      />
    </b-form-group>
    <b-form-group>
      <label>
        {{ trans('mobile') + (isMobileRequired ? ' *' : '') }}
      </label>
      <b-form-input
        ref="mobile"
        type="tel"
        :state="isMobileRequired ? isMobileValid : null"
        v-model="mobile"
        size="sm"
        :disabled="busy"
        @keydown="onKeydown"
        :required="isMobileRequired"
      />
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      initial: String,      
      type: String, // email, sms (or mobile) or both
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: _.extractName(this.initial),
        email: _.extractEmail(this.initial),
        mobile: _.extractMobile(this.initial),
      }
    },
    computed: {
      serialized() {
        return {
          id: _.compact([this.name, this.email, this.mobile]).join(' '),
          name: this.name,
          email: this.email,
          mobile: this.mobile ? _.formatPhone(this.mobile) : null,
        }
      },
      isEmailRequired() {
        return this.type == 'email'
      },
      isMobileRequired() {
        return this.type == 'sms' || this.type == 'mobile'
      },
      isEmailValid() {
        return _.validateEmail(this.email)
      },
      isMobileValid() {
        return _.validatePhone(this.mobile)
      },
      canSave() {
        if (this.isEmailRequired) return this.isEmailValid
        else if (this.isMobileRequired) return this.isMobileValid
        return this.isEmailValid || this.isMobileValid
      },
    },
    methods: {
      onSave(e) {
        this.$emit('added', this.serialized)
        this.$bvModal.hide('add-recipient-modal')
      },
      onShown() {
        this.busy = false
        this.error = null
        this.name = _.extractName(this.initial)
        this.email = _.extractEmail(this.initial)
        this.mobile = _.extractMobile(this.initial)
        if (this.type == 'email' || this.type == 'both') this.$refs.email.focus()
        else this.$refs.mobile.focus()
      },
      onKeydown(e) {
        if (e.keyCode == 13) {
          if (this.canSave) {
            this.error = null
            this.onSave(e)
          } else {
            this.error = trans('invalid')
          }
        }
      },
    },
    mounted() {
      window.addRecipientModal = this
    },
  }
</script>